module.exports = __webpack_public_path__ + "static/media/irf_logo.99eb32a1.svg";